import { render } from "./CardsView.vue?vue&type=template&id=5c8cd32b"
import script from "./CardsView.vue?vue&type=script&lang=js"
export * from "./CardsView.vue?vue&type=script&lang=js"

import "./CardsView.vue?vue&type=style&index=0&id=5c8cd32b&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__